var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBriefcasePlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 120,
    viewBox: "0 0 118 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1291_2142)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 6H63C70.732 6 77 12.268 77 20V30H41V20C41 12.268 47.268 6 55 6Z",
    stroke: "currentColor",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 106,
    height: 84,
    rx: 14,
    stroke: "currentColor",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 54,
    x2: 59,
    y2: 90,
    stroke: "currentColor",
    strokeWidth: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 72,
    x2: 77,
    y2: 72,
    stroke: "currentColor",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1291_2142"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 118,
    height: 120,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcasePlus);
export default __webpack_public_path__ + "static/media/briefcase-plus.dba75cda50f22f5ec86fc10ccd63a450.svg";
export { ForwardRef as ReactComponent };